// This file registers only React-based controllers
import { application } from "./application";

import AlcoolemieController from "./alcoolemie_controller";
application.register("alcoolemie", AlcoolemieController);

import GrossesseController from "./grossesse_controller";
application.register("grossesse", GrossesseController);

import ImcController from "./imc_controller";
application.register("imc", ImcController);

import ImcEnfantController from "./imc_enfant_controller";
application.register("imc_enfant", ImcEnfantController);

import MetabolismeDeBaseController from "./metabolisme_de_base_controller";
application.register("metabolisme_de_base", MetabolismeDeBaseController);

import CalculateurDeSommeilController from "./calculateur_de_sommeil_controller";
application.register("calculateur_de_sommeil", CalculateurDeSommeilController);

import CongeMaterniteController from "./conge_maternite_controller";
application.register("conge-maternite", CongeMaterniteController);

import ReveilController from "./reveil_controller";
application.register("reveil", ReveilController);

import FraisKilometriquesController from "./frais_kilometriques_controller";
application.register("frais-kilometriques", FraisKilometriquesController);

import FrequenceCardiaqueMaximaleController from "./frequence_cardiaque_maximale_controller";
application.register("frequence_cardiaque_maximale", FrequenceCardiaqueMaximaleController);

import PoidsIdealController from "./poids_ideal_controller";
application.register("poids_ideal", PoidsIdealController);

import MasseGrasseController from "./masse_grasse_controller";
application.register("masse_grasse", MasseGrasseController);
import SemaineGrossesseController from "./semaine_grossesse_controller";
application.register("semaine_grossesse", SemaineGrossesseController);

import ClairanceController from "./clairance_controller";
application.register("clairance", ClairanceController);

import GlasgowController from "./glasgow_controller";
application.register("glasgow", GlasgowController);

import HeuresTravailController from "./heures_travail_controller";
application.register("heures_travail", HeuresTravailController);

import ArretMaladieController from "./arret_maladie_controller";
application.register("arret_maladie", ArretMaladieController);

import CongePaterniteController from "./conge_paternite_controller";
application.register("conge_paternite", CongePaterniteController);

import SurfaceCorporelleController from "./surface_corporelle_controller";
application.register("surface_corporelle", SurfaceCorporelleController);

import PaquetAnneeController from "./paquet_annee_controller";
application.register("paquet_annee", PaquetAnneeController);

import FagerstromController from "./fagerstrom_controller";
application.register("fagerstrom", FagerstromController);
